import { LinearTimeline } from './LinearTimeline';
import { Timeline } from './Timeline';
import { ITimeline, TimelineIdentifier } from './types';

interface TimelineOptions {
    /**
     * Zone Loop Policy (seconds)
     */
    loopLength: number;

    /**
     * Shuffles content in a loop
     */
    shuffle: boolean;
}

/**
 * @throws TypeError - when given an invalid timeline type.
 */
export function createTimeline(
    timelineType: TimelineIdentifier,
    options: TimelineOptions
): ITimeline {
    switch (timelineType) {
        case TimelineIdentifier.NORMAL:
            return new Timeline(options.loopLength);
        case TimelineIdentifier.TIME_BASED:
        case TimelineIdentifier.LINEAR:
            return new LinearTimeline(timelineType, options.shuffle);
        default:
            throw new TypeError(`Unknown timeline type ${timelineType}`);
    }
}
